<template>
  <fullscreen v-model="fullscreen">
    <div>
      <div :class="fullscreen ? 'inputPreview-full' : 'inputPreview'"
        style="display: flex; place-content: start; flex-wrap: wrap">
        
        <!-- FIX: Added fallback background color if key isn't in 0-14 list -->
        <div class="p-1 flex items-center" v-for="(legendItem, index) in orgRelationships" :key="index" :style="{ background: colorsFromKey[legendItem.key] || '#0BA5EC', borderRadius:'2em' }">
          <label class="cursor-pointer m-1" :for="'legend-' + index" :style="{ color: '#FFF' }">{{
            legendItem.label }}</label>
          <input class="m-1 cursor-pointer" type="checkbox" :id="'legend-' + index" :value="legendItem"
            v-model="selectedLegends" />
        </div>
      </div>
      <div class="flex items-end bg-white" style="place-content:flex-end">
        <div class="cursor-pointer p-2" @click="toggleFullscreen" >
          <img v-if="fullscreen" style="height: 25px" src="@/assets/images/icons/shrink.png" alt="" />
          <img v-else style="height: 25px" src="@/assets/images/icons/fullscreen.png" alt="" />
        </div>
      </div>
      <div id="network" :class="fullscreen ? 'network-full' : 'network'"></div>
    </div>
  </fullscreen>
</template>

<script>
import {
  DataSet,
  DataView as visDataView,
  Network,
} from "vis-network/standalone/esm/vis-network";
import constants from "@/constants";

export default {
  name: "NetworkGraph",
  data() {
    return {
      legend: [],
      filter: {
        filteredUsers: [],
        filteredUserRelations: [],
      },
      selectedLegends: [],
      allRelationships: [],
      graphData: {
        nodes: [],
        edges: [],
      },
      nodesView: null,
      edgesView: null,
      fullscreen: false,
      colorsFromKey: {
        0: "#FF6347",
        1: "#0BA5EC",
        2: "#7A5AF8",
        3: "#12B76A",
        4: "#FB6514",
        5: "#4E5BA6",
        6: "#F2C046",
        7: "#EE46BC",
        8: "#F36677",
        9: "#808000",
        10: "#FF69B4",
        11: "#C6211B",
        12: "#A52A2A",
        13: "#008080",
        14: "#708090",
      },
      options: {
        layout: { improvedLayout: false },
        interaction: { hover: true },
        physics: {
          forceAtlas2Based: {
            gravitationalConstant: -16,
            springLength: 100,
            springConstant: 0.05,
          },
          maxVelocity: 200,
          solver: "forceAtlas2Based",
          timestep: 0.35,
          stabilization: true,
        },
      },
      constants,
    };
  },
  computed: {
    searchText() {
      return this.$store.state.community.searchText;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    orgConfig() {
      return this.$store.state.organization.organizationConfiguration;
    },
    orgRelationships() {
      // FIX: Removed 'e.key > 0' because new keys are strings
      return this.$store.state.organization.organizationConfiguration.relationship.values.filter(
        (e) => e.key !== 0 && e.key !== "0" && e.label !== "Add Configuration"
      );
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  watch: {
    searchText() {
      this.nodesView.refresh();
    },
    selectedLegends() {
      this.edgesView.refresh();
    },
  },
  methods: {
    edgesFilter(edge) {
      if (this.selectedLegends.length > 0) {
        const selectedLegendsKeys = this.selectedLegends.map(
          (legend) => legend.key
        );
        return selectedLegendsKeys.includes(edge.relation);
      }
      return false;
    },
    nodesFilter(node) {
      if (this.searchText !== "" && this.searchText !== undefined) {
        this.filter = {
          filteredUsers: [],
          filteredUserRelations: [],
        };
        this.filter.filteredUsers = this.graphData.nodes.filter((e) =>
          e.username.toLowerCase().includes(this.searchText.toLowerCase())
        );
        this.filter.filteredUsers.forEach((n) => {
          this.graphData.edges.forEach((e) => {
            if (e.from == n.id || e.to == n.id) {
              this.filter.filteredUserRelations.push(e);
            }
          });
        });
        if (
          node.username.toLowerCase().includes(this.searchText.toLowerCase())
        ) {
          return true;
        }

        if (
          this.filter.filteredUserRelations.some((e) => {
            return e.to == node.id || e.from == node.id;
          })
        ) {
          return true;
        }
        return false;
      }
      return true;
    },

    fetchOrgEmployees(orgId) {
      this.$store
        .dispatch("organization/getOrgEmployeeVisualization", orgId)
        .then((res) => {
          if (res && res.data) {
            const edgesData = res.data.edges.map((item) => {
              return {
                to: item.to,
                arrows: "from",
                from: item.from,
                relation: item.relationship.key,
                color: {
                  // FIX: Added fallback color for newly drawn lines
                  color: this.colorsFromKey[item.relationship.key] || '#0BA5EC',
                },
              };
            });
            this.graphData.edges.push(...edgesData);

            var nodesData = res.data.nodes.map((item) => {
              if (item.image) {
                item.image = `${constants.s3Bucket}/editor/profile-pictures/${item.image}`;
              } else {
                item.image = `https://hostedboringavatars.vercel.app/api/beam?name=${this.avatarNameGenerator(
                  item.id,
                  item.id
                )}`;
              }
              return {
                id: item.id,
                image: item.image,
                shape: "circularImage",
                username: item.title,
                title: this.createUserCard(
                  item,
                  this.graphData.edges.filter(
                    (x) => x.to == item.id || x.from == item.id
                  ).length
                ),
              };
            });

            this.graphData.nodes.push(...nodesData);

            this.nodesView = new visDataView(
              new DataSet(this.graphData.nodes),
              { filter: this.nodesFilter }
            );
            this.edgesView = new visDataView(
              new DataSet(this.graphData.edges),
              { filter: this.edgesFilter }
            );
            this.initializeNetwork();
          }
        })
        .catch(() => { });
    },

    createUserCard(item, relationshipCount) {
      var mainDiv = document.createElement("div");
      mainDiv.style.padding = "10px";
      mainDiv.style.margin = "0";
      mainDiv.style.background = "white";
      mainDiv.style.display = "flex";
      mainDiv.style.placeItems = "center";


      var div = document.createElement("div");
      div.style.position = "absolute";
      div.style.top = "0";
      div.style.left = "0";
      div.style.width = "100%";
      div.style.height = "100%";
      div.style.background = "white";
      div.style.zIndex = "-1";
      div.style.padding = "0";

      var userInfoDiv = document.createElement("div");
      userInfoDiv.style.paddingLeft = "1em";
      userInfoDiv.style.margin = "0";
      userInfoDiv.style.background = "white";
      userInfoDiv.style.display = "block";

      var userNameElement = document.createElement("p");
      userNameElement.style.margin = "0";
      userNameElement.style.padding = "0";
      userNameElement.style.textAlign = "left";
      userNameElement.style.fontWeight = "bold";
      userNameElement.style.fontSize = "17px";
      userNameElement.style.color = "black";
      userNameElement.style.position = "relative";
      userNameElement.innerHTML = item.title;

      var imageElement = document.createElement("img");
      imageElement.style.borderRadius = "50%";
      imageElement.style.objectFit = "cover";
      imageElement.style.objectPosition = "center";
      imageElement.style.position = "relative";
      imageElement.style.top = "0";
      imageElement.style.left = "0";
      imageElement.style.width = "4em";
      imageElement.style.height = "4em";
      imageElement.style.marginLeft = "auto";
      imageElement.style.marginRight = "auto";
      imageElement.style.display = "block";
      imageElement.src = item.image;

      var relationElement = document.createElement("p");
      relationElement.style.margin = "0";
      relationElement.style.padding = "0";
      relationElement.style.textAlign = "left";
      relationElement.style.fontSize = "12px";
      relationElement.style.fontWeight = "semi-bold";
      relationElement.style.color = "black";
      relationElement.style.position = "relative";
      relationElement.style.whiteSpace = "initial";
      relationElement.style.overflow = "hidden";
      relationElement.style.textOverflow = "elipsis";
      relationElement.innerHTML = `${item.title} has ${relationshipCount} ${relationshipCount > 1 ? "relations" : "relation"
        }`;

      userInfoDiv.appendChild(userNameElement);
      userInfoDiv.appendChild(relationElement);

      mainDiv.appendChild(div);
      mainDiv.appendChild(imageElement);
      mainDiv.appendChild(userInfoDiv);
      return mainDiv;
    },

    initializeNetwork() {
      const container = document.getElementById("network");
      const data = { nodes: this.nodesView, edges: this.edgesView };
      this.network = new Network(container, data, this.options);
      
      // Auto-select first two if available
      if(this.orgRelationships.length > 0) this.selectedLegends.push(this.orgRelationships[0]);
      if(this.orgRelationships.length > 1) this.selectedLegends.push(this.orgRelationships[1]);
    },
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
  },
  mounted() {
    this.fetchOrgEmployees(this.orgData._id);
  },
};
</script>

<style scoped>
.checkbox {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}

.inputPreview-full {
  gap: 20px;
  justify-content: center;
  background-color: white;
  padding-top: 2rem;
  padding-left: 2rem;
}

.inputPreview {
  gap: 20px;
  justify-content: center;
  background-color: white;
}

.checkbox+label {
  position: relative;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 20px;
  color: rgb(0, 0, 0);
}

.checkbox+label::before {
  content: " ";
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
  width: 16px;
  height: 16px;
  background-color: white;
  border-width: 2px;
  border-style: solid;
  border-color: rgba(var(--vs-primary, "#F2C244"), 1);
  border-radius: 10px;
  box-shadow: none;
}

.checkbox:checked+label::after {
  content: " ";
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: center center;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0px;
  left: 0px;
  top: 0px;
  text-align: center;
  border-radius: 10px;
  background-color: rgba(var(--vs-primary, "#F2C244"), 1);
  font-size: 10px;
  height: 20px;
  width: 20px;
}

.network-full {
  width: 100%;
  height: 100vh;
  background-color: white;
}

.network {
  width: 100%;
  height: 55vh;
}
</style>